import { post } from '@/services/request';

/** 获取街道办事处列表 */
export const getLocationOfficeList = (params: { districtCode: number | string }) =>
  post('/locationOffice/list', params);